export default __webpack_public_path__ + "static/media/28.4d55cf3e.jpg";